import React, { PureComponent } from 'react';
import styled from 'styled-components';

import MachineOptionsImage from '../../../containers/assets/onboarding-machine-options.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  p {
    margin-bottom: 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  b {
    font-weight: 700;
    color: rgba(0, 27, 59, 1);
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

class MachineOptions extends PureComponent {

  render() {
    return (
      <Wrapper>
        <Container>
          <Text1>What to expect</Text1>
          <Text2>Manufacturing Machine Options</Text2>
          <Text3>
            <p>Also, your team will have new Ops decisions to consider.  Machine options is one and these are the options:  </p>
            <p><b>Option 1:</b> Keep existing production lines with no changes.</p>
            <p><b>Option 2:</b> Keep existing production line and buy additional lines.</p>
            <p><b>Option 3:</b> Sell the existing production line and upgrade to another line.</p>
            <p><b>Note:</b> If you sell a production line that was purchased in the prior year, you won’t be able to buy it back in the current round. You’ll have to wait until the next round.</p>
          </Text3>

          <Image>
            <img src={MachineOptionsImage} alt="" />
          </Image>
        </Container>
      </Wrapper>
    );
  }

}

export default MachineOptions;



// WEBPACK FOOTER //
// ./src/components/onboarding/what-to-expect/MachineOptions.js